import $ from "jquery";
import debug from 'bows/dist/bows.min.js';


let $slidersOneAcross = $('[data-slider="one-across"]');
let inEditor = $('[data-title="Certification Program"]')
let isEditor = true;

const log = debug("sliders:one-across");


function sliderInit() {

	$slidersOneAcross.each(function () {
		let $this = $(this);
		let role = $this.attr('role');
		let post_slider = $this.closest('.post-slider');
		let prev = post_slider.find('button[data-direction="prev"]');
		let next = post_slider.find('button[data-direction="next"]');
		let slider = '';
		if (role !== 'region') {
			slider = $this.slick({
				dots: true,
				speed: 500,
				slidesToShow: 1,
				arrows: false,
			});

			prev.on('click', function () {
				slider.slick('slickPrev');
			});
			next.on('click', function () {
				slider.slick('slickNext');
			});

			window.ctia_sliders.push(slider);
		}
	});
}

// Allows buttons to work in editor
function editorSlides() {
	$('body').unbind('click').on('click', '[data-slidetype="one-across"]', function () {
		let direction = $(this).data('direction');

		let post_slider = $(this).closest('.post-slider');
		let posts_slides = post_slider.find('.post-card');
		let active_slide = post_slider.find('.post-card--editor');


		if (direction === 'next') {
			let next_slide = active_slide.next();
			if (next_slide.length === 0) {
				next_slide = posts_slides.first();
			}
			active_slide.removeClass('post-card--editor');
			next_slide.addClass('post-card--editor')
		} else if (direction === 'prev') {
			let prev_slide = active_slide.prev();
			if (prev_slide.length === 0) {
				prev_slide = posts_slides.last();
			}
			active_slide.removeClass('post-card--editor');
			prev_slide.addClass('post-card--editor')
		}
	});
}

$(function () {
	if ($slidersOneAcross.length && inEditor.length == 0) {
		sliderInit();
	} else {
		editorSlides();
	}

})

